import { observable } from 'mobx'
import Model from '../shared/model'
import { i18n } from '../shared/utils'

export default class Image extends Model {

  @observable i18n = {}

  get original() {
    return i18n(this, 'draft.original')
  }

  get channels() {
    return i18n(this, 'draft.channels')
  }

  get thumbnails() {
    return i18n(this, 'draft.thumbnails')
  }

  get constraints() {
    return i18n(this, 'draft.constraints')
  }

  static defaultAttributes = {
    constraints: {},
    shouldIntersect: false,
    file: null
  }

  constructor(store, rawData = {}, opts = {}) {
    if (!store) {
      console.error('model creation requires a store')
    }
    // set standard properties (like store) and calls parse, set, and handleModelCreated
    super(store, rawData, opts)
  }

  clone(data: Object = {}): Object {
    const file = data.file
    delete data.file
    const clone = JSON.parse(JSON.stringify(data))
    if (file) {
      clone.file = file
    }
    return clone
  }

  /**
   * Setting data is an edge case if there is a file object
   * within data. So this gets some special treatment here.
   */
  set(data) {

    this.file = data.file

    if (data.file) {
      delete data.file
    }

    super.set(data)

  }

  setMetas(metas, lang = null) {
    i18n(this, 'alt', lang, metas.alt)
    i18n(this, 'title', lang, metas.title)
  }

  getJSON() {
    const sourceType = this.file ? 'file' : 'url'
    return {
      id: this.id,
      original: this.original,
      thumbnails: this.thumbnails,
      version: this.version,
      channels: this.channels,
      constraints: this.constraints,
      shouldIntersect: this.shouldIntersect,
      languageReferences: this.languageReferences,
      [sourceType]: this[sourceType],
      projectId: this.projectId,
      alt: this.alt,
      title: this.title
    }
  }

  parse(data) {

    if (data.data) {
      data = data.data
    }

    return data

  }

}
